/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_DomainsInputs */

const en_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Domains`)
};

const es_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dominios personalizados`)
};

const fr_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domaines personnalisés`)
};

const de_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigene Domains`)
};

const ja_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独自ドメイン`)
};

const zh_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义域名`)
};

const ar_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نطاقات مخصصة`)
};

const id_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Kustom`)
};

const it_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domini Personalizzati`)
};

const ru_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Собственные домены`)
};

const pt_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domínios Personalizados`)
};

const ko_custom_domains = /** @type {(inputs: Custom_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤형 도메인`)
};

/**
* | output |
* | --- |
* | "Custom Domains" |
*
* @param {Custom_DomainsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const custom_domains = /** @type {((inputs?: Custom_DomainsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_DomainsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_custom_domains(inputs)
	if (locale === "es") return es_custom_domains(inputs)
	if (locale === "fr") return fr_custom_domains(inputs)
	if (locale === "de") return de_custom_domains(inputs)
	if (locale === "ja") return ja_custom_domains(inputs)
	if (locale === "zh") return zh_custom_domains(inputs)
	if (locale === "ar") return ar_custom_domains(inputs)
	if (locale === "id") return id_custom_domains(inputs)
	if (locale === "it") return it_custom_domains(inputs)
	if (locale === "ru") return ru_custom_domains(inputs)
	if (locale === "pt") return pt_custom_domains(inputs)
	return ko_custom_domains(inputs)
});